import { ReactNode } from 'react';
import { Link, useLocation } from 'wouter';
import { ADMIN_ROUTES } from '../routes/consts';
import cx from 'classix';

type NavItemProps = {
  href: string;
  children: ReactNode;
};

const AdminNavItem = (props: NavItemProps) => {
  const { href, children } = props;
  const [location] = useLocation();
  const match = location === href || location.startsWith(href + '/');
  return (
    <li>
      <Link
        className={cx(
          'hover:text-brand-600 text-black font-semibold px-2 py-1 flex items-center',
          match ? 'bg-blue-200 rounded-t-md' : '',
        )}
        to={href}
      >
        {children}
      </Link>
    </li>
  );
};

export const AdminNav = () => {
  return (
    <nav className='p-2 flex justify-center'>
      <ul className='whitespace-nowrap flex text-xs box-border overflow-x-auto'>
        <AdminNavItem href={ADMIN_ROUTES.HOME}>Home</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.ORGANIZATIONS}>Organizations</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.PROJECTS}>Projects</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.INTRODUCTIONS}>Introductions</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.PROFESSIONALS}>Professionals</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.REPRESENTATIVES}>Representatives</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.PARTNERS}>Partners</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.COHORTS}>Cohorts</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.TEAMS}>Teams</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.JOB_POSTINGS}>Job&nbsp;Postings</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.EVENTS}>Events</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.COMMUNITY_WINS}>Community&nbsp;Wins</AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.COMMUNITY_ANNOUNCEMENTS}>
          Community&nbsp;Announcements
        </AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.FUNDING_OPPORTUNITIES}>
          Funding&nbsp;Opportunities
        </AdminNavItem>
        <AdminNavItem href={ADMIN_ROUTES.MEETINGS}>Meetings</AdminNavItem>
      </ul>
    </nav>
  );
};
